import { Chip, styled } from '@mui/material';

declare module '@mui/material/Chip' {
  interface ChipPropsSizeOverrides {
    large: true;
  }
}

export const ExtendedChip = styled(Chip)(({ theme }) => ({
  '&.MuiChip-sizeLarge': {
    height: '40px',
    fontSize: theme.typography.pxToRem(16),
    padding: theme.spacing(0, 2),

    '& .MuiChip-icon': {
      fontSize: theme.typography.pxToRem(24),
      marginLeft: theme.spacing(1),
      marginRight: theme.spacing(-0.5),
    },

    '& .MuiChip-avatar': {
      width: '32px',
      height: '32px',
      fontSize: theme.typography.pxToRem(16),
    },

    '& .MuiChip-label': {
      paddingLeft: theme.spacing(1.5),
      paddingRight: theme.spacing(1.5),
    },
  },
}));
